import type { Technique } from '../types';
import { BOIDS_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type BoidsState } from './render';

export const boids: Technique<BoidsState> = {
  id: 'boids',
  name: 'Boids / Schwarm',
  category: 'field',
  description: 'Schwarm aus Separation, Alignment und Cohesion — formt, umkreist oder meidet den Text.',
  params: BOIDS_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
